import React, { createContext, useEffect, useMemo, useRef, useState } from 'react'
import { RENDER_SDK, RESOURCE_MANAGER } from '@/config'
import Scene from '../RenderComp/Scene'
import { ModifiedRenderKit } from '@/packages/sdk/fu_render_kit/lib/RenderKitSDK'
import './index.scss'
import { CompTypes } from '@/App'
import { useLocation } from 'react-router-dom'
import { Spin } from 'antd'

// 获取拥有的avatars
function getEnableAvatars() {
    const requests: Promise<any>[] = []

    if (RESOURCE_MANAGER.defaultAvatarList.length) {
        RESOURCE_MANAGER.defaultAvatarList.forEach(avatar => {
            requests.push(Promise.resolve(avatar))
        })
    }
    return Promise.all(requests)
}

export const RendererContext = createContext<{
    renderer?: ModifiedRenderKit
    setRenderer: React.Dispatch<React.SetStateAction<ModifiedRenderKit | undefined>>
    comp?: CompTypes
    loading: boolean
    setLoading: any
}>({
    setRenderer: () => { },
    loading: true,
    setLoading: () => { },
})

const RenderKit = (props) => {
    const [loading, setLoading] = useState(true)
    const loc = useLocation()
    const comp: any = useMemo(() => {
        return loc.pathname.split('/').pop()
    }, [loc.pathname])
    const [renderer, setRenderer] = useState<ModifiedRenderKit | undefined>(undefined)

    useEffect(() => {
        RESOURCE_MANAGER.initialize({ sdk: RENDER_SDK }).then(() => {
            Promise.all([
                RESOURCE_MANAGER.getAnimationList(),
                RESOURCE_MANAGER.getAllBundleList()
            ]).then(async () => {
                // 1. 初始化 RENDER_SDK 和 用来提供资源拉取和缓存管理的 RESOURCE_MANAGER; RESOURCE_MANAGER 可按实际情况自定义扩展
                // RENDER_SDK 初始化会加载 wasm 和 data，完成渲染引擎初始化
                // RESOURCE_MANAGER 初始化会完成资源信息的拉取
                await RENDER_SDK.initialize()
                await Promise.all([
                    RENDER_SDK.authWithAuthpack(
                        'authpack.bin',   // url of authpack.bin 
                        RESOURCE_MANAGER.api.getAuthData.bind(RESOURCE_MANAGER)  // 鉴权 api 接口实现
                    ),
                    getEnableAvatars()
                ])
                // 可选择关闭 log 输出
                RENDER_SDK.RenderKit?.setLogLevel(RENDER_SDK.EFuRenderLoggerLevel.LOG_LEVEL_INFO);
                renderkitInit()
            })
        })
    }, [])

    async function renderkitInit() {
        // 2. 创建全局 renderer, 创建场景，根据需要设置场景的光照、相机和背景
        const renderer = RENDER_SDK._modifiedRenderer
        await renderer?.initialize({
            canvas: document.getElementById("canvas"),
        })
        setRenderer(renderer)

    }

    return (
        <>
            <Spin spinning={loading}>
                <RendererContext.Provider value={
                    {
                        renderer,
                        setRenderer,
                        comp,
                        loading,
                        setLoading,
                    }
                }>
                    <Scene />
                </RendererContext.Provider>
            </Spin>
        </>
    )
}

export default RenderKit
